import { Link } from "react-router-dom";

const Settings = () => {
  return (
    <div className="relative mb-10 mt-12 px-2.5 text-center md:px-3 lg:px-5">
      <div className="box mx-auto max-w-[800px] overflow-hidden bg-white dark:bg-darkPrimary md:px-[25px]">
        <div className="relative h-[130px] w-full overflow-hidden">
          <div className="header-back1"></div>
          <div className="z-10 flex h-[130px] flex-col items-center justify-center text-white">
            <h1 className="text-header z-10 mb-1">Terms of Service</h1>
            <p className="z-10 ">Last updated: June, 2022</p>
          </div>
        </div>
        <div className="mx-3 my-8 text-left md:mx-0">
          <p className="mb-3">
            These Terms of Service ("Terms") govern your use of the BBAScan
            website and its related services (collectively, the "Services")
            provided by BTI Group OÜ. By accessing or using our Services, you
            agree to these Terms. If you do not agree, please discontinue using
            our Services.
          </p>

          <div className="my-3">
            <p className="mb-3 font-bold">1. General Information</p>
            <ul className="mb-3 ml-6 list-disc">
              <li>
                <span className="font-bold">Company Name: </span>
                <span>BTI Group OÜ</span>
              </li>
              <li>
                <span className="font-bold">Address:</span>
                <span>Tornimäe tn 3, Tallinn, Estonia 10145</span>
              </li>
              <li>
                <span className="font-bold">Contact: </span>
                <Link
                  to="https://bbascan.com/contact"
                  className="underline"
                  target="_blank"
                >
                  https://bbascan.com/contact
                </Link>
              </li>
            </ul>
            <p>
              BBAScan is a blockchain explorer and analytics platform tailored
              for the BBAChain blockchain. By using our Services, you
              acknowledge that BBAScan acts as a tool to explore blockchain data
              and does not guarantee the accuracy, reliability, or completeness
              of the information provided.
            </p>
          </div>

          <div className="my-3">
            <p className="mb-3 font-bold">2. Acceptance of Terms</p>
            <p className="mb-3">
              By using the BBAScan website and Services, you agree to:
            </p>
            <ul className="mb-3 ml-6 list-disc">
              <li>Comply with all applicable laws and regulations.</li>
              <li>
                Not use the Services for any unlawful, fraudulent, or malicious
                purposes.
              </li>
              <li>
                Adhere to these Terms and any applicable additional guidelines
                or policies.
              </li>
            </ul>
          </div>

          <div className="my-3">
            <p className="mb-3 font-bold">3. Services Provided</p>
            <p className="mb-3">
              BBAScan offers tools and features, including but not limited to:
            </p>
            <ul className="mb-3 ml-6 list-disc">
              <li>
                Real-time transaction tracking on the BBAChain blockchain.
              </li>
              <li>Token and NFT activity monitoring.</li>
              <li>Smart contract analysis and interaction.</li>
              <li>Advanced search and filtering options.</li>
              <li>APIs for developers to integrate blockchain data.</li>
            </ul>
            <p className="mb-3">
              BBAScan provides information and analytics for educational and
              informational purposes only and is not intended for financial or
              investment advice.
            </p>
          </div>

          <div className="my-3">
            <p className="mb-3 font-bold">4. Prohibited Uses</p>
            <p className="mb-3">
              You agree not to use BBAScan for the following:
            </p>
            <ul className="mb-3 ml-6 list-disc">
              <li>
                Engaging in unlawful activities or violating applicable laws.
              </li>
              <li>
                Distributing viruses, malware, or other harmful technologies.
              </li>
              <li>
                Accessing or attempting to access unauthorized areas of the
                website.
              </li>
              <li>
                Overloading, disrupting, or impairing the Services
                infrastructure.
              </li>
              <li>
                Misrepresenting data or impersonating another individual or
                entity.
              </li>
            </ul>
          </div>

          <div className="my-3">
            <p className="mb-3 font-bold">5. Accuracy of Information</p>
            <p className="mb-3">
              BBAScan strives to provide accurate and up-to-date blockchain
              data. However, due to the nature of blockchain technology, we
              cannot guarantee the accuracy, reliability, or completeness of the
              data presented. Users are encouraged to verify information
              independently.
            </p>
          </div>

          <div className="my-3">
            <p className="mb-3 font-bold">6. Intellectual Property</p>
            <p className="mb-3">
              All intellectual property rights in BBAScan’s website, features,
              and content are owned by BTI Group OÜ. You may not use, reproduce,
              modify, or distribute any part of BBAScan’s content without prior
              written permission.
            </p>
          </div>

          <div className="my-3">
            <p className="mb-3 font-bold">7. Limitation of Liability</p>
            <p className="mb-3">
              BBAScan and BTI Group OÜ are not responsible for:
            </p>
            <ul className="mb-3 ml-6 list-disc">
              <li>
                Any direct, indirect, incidental, or consequential damages
                resulting from your use of the Services.
              </li>
              <li>Errors, inaccuracies, or delays in the data provided.</li>
              <li>
                Losses resulting from blockchain transactions or third-party
                interactions.
              </li>
            </ul>
            <p className="mb-3">The use of BBAScan is at your own risk. </p>
          </div>

          <div className="my-3">
            <p className="mb-3 font-bold">8. Privacy Policy</p>
            <p className="mb-3">
              Your use of BBAScan is also governed by our Privacy Policy, which
              explains how we collect, use, and protect your information.
            </p>
          </div>

          <div className="my-3">
            <p className="mb-3 font-bold">9. Termination</p>
            <p className="mb-3">
              BTI Group OÜ reserves the right to suspend or terminate access to
              BBAScan without prior notice if you violate these Terms or if
              required by law.
            </p>
          </div>

          <div className="my-3">
            <p className="mb-3 font-bold">10. Modifications to the Terms</p>
            <p className="mb-3">
              BTI Group OÜ reserves the right to modify or update these Terms at
              any time. Changes will be communicated via updates on the BBAScan
              website. Continued use of the Services constitutes acceptance of
              the revised Terms.
            </p>
          </div>

          <div className="my-3">
            <p className="mb-3 font-bold">11. Governing Law and Jurisdiction</p>
            <p className="mb-3">
              These Terms shall be governed by and construed in accordance with
              the laws of Estonia. Any disputes arising out of or related to
              these Terms shall be subject to the exclusive jurisdiction of the
              courts in Tallinn, Estonia.
            </p>
          </div>

          <div className="my-3">
            <p className="mb-3 font-bold">12. Contact Information</p>
            <p className="mb-3">
              For any questions or concerns, please contact us at:
              <Link
                to="https://bbascan.com/contact"
                className="underline"
                target="_blank"
              >
                https://bbascan.com/contact
              </Link>
            </p>
          </div>

          <div className="my-3">
            <p className="mb-1 font-bold">BTI Group Labs</p>
            <p className="mb-3">
              <Link to="mailto:developers@btigroup.ee">
                developers@btigroup.ee
              </Link>
            </p>
            <p>By using BBAScan, you agree to these Terms of Service.</p>
            <p>Thank you for being a part of the BBAChain ecosystem!</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Settings;
